import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

const isIE = globalThis.navigator.userAgent.includes('MSIE ') || globalThis.navigator.userAgent.includes('Trident/');
const userGraph = 'user.read';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.CLIENT_ID,
      authority: environment.ENVIRONMENT_AUTHORITY,
      redirectUri: environment.REDIRECT_URI,
      postLogoutRedirectUri: environment.POST_LOGOUT_REDIRECT_URI,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com', [userGraph]);
  protectedResourceMap.set(environment.SERVER_URL, [`${environment.CLIENT_ID}/.default`]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  } as MsalInterceptorConfiguration;
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [userGraph],
    },
  } as MsalGuardConfiguration;
}
